import makeTypeCreator from '@/models/makeTypeCreator'

const createType = makeTypeCreator('notifies')

export const FETCH_LIST = createType('FETCH_LIST')
export const LIST_FETCHED = createType('LIST_FETCHED')
export const SHOW_INFO_DIALOG = createType('SHOW_INFO_DIALOG')
export const HIDE_INFO_DIALOG = createType('HIDE_INFO_DIALOG')
export const TOGGLE_LOADING = createType('TOGGLE_LOADING')
export const READ_USER_NOTIFY = createType('READ_USER_NOTIFY')
export const UPDATED = createType('UPDATED')
export const SHOW_SEND_NOTIFY_DIALOG = createType('SHOW_SEND_NOTIFY_DIALOG')
export const DELETE_NOTIFY = createType('DELETE_NOTIFY')
export const SEND_NOTIFY_HISTORY_DIALOG = createType('SEND_NOTIFY_HISTORY_DIALOG')
export const FETCH_USER_NOTIFY_LIST = createType('FETCH_USER_NOTIFY_LIST')
export const DELETE_USER_NOTIFY = createType('DELETE_USER_NOTIFY')
export const READ_USER_ALL_NOTIFY = createType('READ_USER_ALL_NOTIFY')
export const SEND_MESSAGE = createType('SEND_MESSAGE')
export const NOTIFY_FETCHED = createType('NOTIFY_FETCHED')
export const FETCH_NOTIFY_CENTER_MESSAGE = createType('FETCH_NOTIFY_CENTER_MESSAGE')
export const NO_DO_FEEDBACK_NUM = createType('NO_DO_FEEDBACK_NUM')
export const FETCH_NO_DO_FEEDBACK_NUM = createType('FETCH_NO_DO_FEEDBACK_NUM')




